import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "contact-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "联系我们", -1)
const _hoisted_3 = { class: "contact" }
const _hoisted_4 = { class: "code-box" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "客服微信二维码", -1)
const _hoisted_7 = { class: "phone-box" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "title" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "concat-text" }, "联系方式", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("我知道了")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_buttons = _resolveComponent("buttons")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createBlock(_component_van_dialog, {
    show: _ctx.isShowContact,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isShowContact) = $event)),
    "show-confirm-button": false,
    class: "contact-dialog",
    "show-cancel-button": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _ctx.imgUrl + '&key=' + _ctx.contantDetail.wechatQrCode,
              alt: ""
            }, null, 8, _hoisted_5),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              src: _ctx.parseImgUrl('ipdImages', 'phone-icon.svg'),
              alt: ""
            }, null, 8, _hoisted_8),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.contantDetail.phone), 1),
            _hoisted_10
          ])
        ]),
        _createVNode(_component_buttons, {
          class: "dailog-btn",
          onClick: _ctx.closeDailog
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}